  import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Syllabus {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-syllabus',
  templateUrl: './syllabus.component.html',
  styleUrls: ['./syllabus.component.css'],
  providers: [HelperService] 
})

export class SyllabusComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
  @ViewChild(DataTableDirective)

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  syllabuses: Syllabus[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  syllabus='';
  syllabus_id=0;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private router: Router) {
   
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
    .map(this.extractData)
    .subscribe(syllabuses => {
      this.syllabuses = syllabuses;
    
        this.dtTrigger.next();
     
    });
  }
  

  editClick(id,name){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.syllabus=name;
    this.syllabus_id=id;
  }
  addClick(e){
    
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  delete_syllabusClick(id){
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 3000,
      extraClasses:  ['warning-snackbar'],
    }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/delete/syllabus/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => this.refresh('Syllabus Removed successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
   
  }


 refresh(msg='',val=false){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/syllabus"]));
  
      
 }
 addSyllabus(addForm: NgForm){
  let body = new FormData();
  body.append('name', addForm.value.name);


   this.http.post(this.helper.base_url+'http/add/syllabus', body,{ headers: this.headers })
   .subscribe(
     (res) => {
      this.listClick(null) ;
      this.refresh('Syllabus added successfully ') ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 updateSyllabus(updateForm: NgForm){
   let id =this.syllabus_id;
  let body = new FormData();

  body.append('name', updateForm.value.name);

   this.http.post(this.helper.base_url+'http/update/syllabus/'+id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
      this.listClick(null) ;
      this.refresh('Syllabus updated successfully') ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

}



// WEBPACK FOOTER //
// ./src/app/syllabus/syllabus.component.ts